export default __webpack_public_path__ + "static/media/CNH_front.8a90c193.png";